import * as z from "zod";

import { associationSchema } from "./association";
import { userSchema } from "./user";

export const userAssociationSchema = associationSchema.omit({
  integrations: true,
  entityFileTypes: true,
  additionalFields: true,
});

export const userContextSchema = userSchema.extend({
  type: z.literal("user"),
});

export const userAssociationContextSchema = userSchema.extend({
  association: userAssociationSchema,
  isOwner: z.boolean(),
  type: z.literal("associationUser"),
});

export const associationContextSchema = userAssociationSchema.extend({
  type: z.literal("association"),
});

export const authContextSchema = z.discriminatedUnion("type", [
  userContextSchema,
  userAssociationContextSchema,
  associationContextSchema,
]);

export type UserAssociation = z.infer<typeof userAssociationSchema>;

export type AuthContext = z.infer<typeof authContextSchema>;
export type UserContext = z.infer<typeof userContextSchema>;
export type UserAssociationContext = z.infer<
  typeof userAssociationContextSchema
>;
export type AssociationContext = z.infer<typeof associationContextSchema>;
